<template>
	<div class="relative">
		<el-image v-if="value" :src="value" style="width:100px;height:100px;"></el-image>
		<el-upload :action="origin+'/api/file/upload/oss'" :headers="headers" :show-file-list="false"
			:on-success="onSuccess" :on-error="onError" :on-remove="onRemove" :limit="1" accept="image/*">
			<el-button size="mini" type="primary">upload</el-button>
		</el-upload>
	</div>

</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {},
		props: {
			value: String,
			mode: String,
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				headers: request.makeHeaders(),
			}
		},
		mounted() {



		},
		methods: {
			onChange(file, fileList) {
				console.log('onChange', file, fileList)
			},
			onSuccess(resp, file, fileList) {
				file.url = resp.data.url;
				this.$emit('change', file.url);
				this.headers = request.makeHeaders();
			},
			onError(err, file, fileList) {
				console.log('onError', err, file, fileList)
			},
			onRemove(file, fileList) {
				this.$emit('change', file.url);
				this.headers = request.makeHeaders();
			},
		}
	}
</script>

<style>

</style>